import React, { FC } from 'react';
import styled from 'styled-components';

import LoaderOverlay from '@/presentation/loader/LoaderOverlay';

const SButtonsLoaderContainer = styled.div`
  display: inline-block;
  position: relative;
`;

interface IButtonsLoaderContainerProps {
  width?: string;
  children: React.ReactNode;
  showLoader?: boolean;
}

const ButtonsLoaderContainer: FC<IButtonsLoaderContainerProps> = ({ width = 'auto', children, showLoader = false }) => (
  <SButtonsLoaderContainer style={{ width: width }}>
    {showLoader && <LoaderOverlay />}
    {children}
  </SButtonsLoaderContainer>
);

export default ButtonsLoaderContainer;
